import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGetApiClients, fetchPostApiClient, fetchToggleApiClient, fetchDeleteApiClient,
  fetchGetApiTokens, fetchPostApiToken, fetchRevokeApiToken, fetchDeleteApiToken, fetchGetApiAuditLog,
  fetchGetProjects, fetchGetTemplates,
  cleanUpApiToken, cleanUpMessageApiToken,
} from 'state-managament/apiToken.slice';

export default function useApiToken() {
  const { error, success, isLoaded, data, projects, templates } = useSelector((state) => state.apiToken);
  const dispatch = useDispatch();

  return {
    error, success, isLoaded, data, projects, templates,
    cleanUp:           ()     => dispatch(cleanUpApiToken()),
    cleanUpMessage:    ()     => dispatch(cleanUpMessageApiToken()),
    getClients:        (args) => dispatch(fetchGetApiClients(args)),
    postClient:        (args) => dispatch(fetchPostApiClient(args)),
    toggleClient:      (args) => dispatch(fetchToggleApiClient(args)),
    deleteClient:      (args) => dispatch(fetchDeleteApiClient(args)),
    getTokens:         (args) => dispatch(fetchGetApiTokens(args)),
    postToken:         (args) => dispatch(fetchPostApiToken(args)),
    revokeToken:       (args) => dispatch(fetchRevokeApiToken(args)),
    deleteToken:       (args) => dispatch(fetchDeleteApiToken(args)),
    getAuditLog:       (args) => dispatch(fetchGetApiAuditLog(args)),
    getProjects:       (args) => dispatch(fetchGetProjects(args)),
    getTemplates:      (args) => dispatch(fetchGetTemplates(args)),
  };
}
